import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button,
    Popconfirm,
} from 'antd';

import { asyncGet, actions } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import Edit from './edit.js';
import { delect, delectAll } from './reducers';

class AgencyAnalysis extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    reStart = record => {
        const { scriptId } = record;
        this.props.reStart({ scriptIds: [scriptId], action: '7', executeNow: true });
        this.props.asyncGet();
    }

    edit = record => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record.scriptId);
    }

    handleDelete = async record => {
        record.deleteFlag = '1';
        this.props.delect(record);
        this.props.asyncGet();
    }

    renderAction = (text, record) => {
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => { this.edit(record); }} >
                    编辑
                </Button>

                <Popconfirm title="是否删除?" onConfirm={() => { this.handleDelete(record); }} >
                    <Button type="primary" style={{ marginRight: '5px' }} size="small">
                        < a href="#">删除</a>
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    onSelectChange = (selectedRowKeys, selectedRows) => { //selectedRowKeys  指定选中项的 key 数组
        this.props.getTransferData({ selectedRowKeys });
        this.props.getSele(selectedRowKeys);
    }

    render() {
        let { list, uiStatus, pagination, transferData } = this.props;
        const { selectedRowKeys } = transferData;
        let { isLoading } = uiStatus;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const columns = [
            {
                title: '脚本ID',
                dataIndex: 'scriptId',
                key: 'scriptId',
            },
            {
                title: '脚本名称',
                dataIndex: 'scriptName',
                key: 'scriptName',
            },
            {
                title: '下载地址',
                dataIndex: 'downloadUrl',
                key: 'downloadUrl',
            },
            {
                title: '存放路径',
                dataIndex: 'savePath',
                key: 'savePath',
            },
            {
                title: '适用系统',
                dataIndex: 'applySys',
                key: 'applySys',
            },
            {
                title: '脚本内容',
                dataIndex: 'scriptContent',
                key: 'scriptContent',
            },
            {
                title: '创建时间',
                dataIndex: 'ceateTime',
                key: 'ceateTime',
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={{
                            ...pagination,
                        }}
                        defaultExpandAllRows={false}
                        onChange={this.changeHandle}
                        rowSelection={rowSelection}
                    />
                    <Edit />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    selectedContent: state.scriptList.selectedContent,
    list: state.scriptList.list,
    pagination: state.scriptList.pagination,
    proxyrepeatinfo: state.scriptList.proxyrepeatinfo,
    uiStatus: state.scriptList.uiStatus,
    agentsGroup: state.scriptList.agentsGroup,
    transferData: state.scriptList.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    delUser: id => dispatch(actions.del(id)),
    delect: record => dispatch(delect(record)),
    delectAll: selectedRowsCurr1 => dispatch(delectAll(selectedRowsCurr1)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
    getUserGroups: () => dispatch(getUserGroups()),
    getSele: data => dispatch(actions.getSele(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);



// WEBPACK FOOTER //
// ./pages/client/scriptList/index.js